import type { Location } from '@core/Router/locations';
import { lazy } from 'react';

const ProtestPageContainer = lazy(() =>
    import(/* webpackChunkName: "insurance" */ '@insurance/ui/ProtestPage').then(m => ({ default: m.ProtestPage })),
);
const ProtestItemPageContainer = lazy(() =>
    import(/* webpackChunkName: "insurance" */ '@insurance/ui/ProtestActItemPage').then(m => ({
        default: m.ProtestItemPage,
    })),
);

export const protestLocations: Location[] = [
    {
        url: '/insurance/act',
        Component: ProtestPageContainer,
    },
    {
        url: '/insurance/act/:actId',
        Component: ProtestItemPageContainer,
    },
];
